// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"352":"15a8773f","712":"b4ee6a8a","981":"4a460161"}[chunkId] + ".chunk.css";
};